<template>
	<div class="table">
		<div class="title">{{ tableData.name }}</div>
		<div class="content">
			<b-tr class="tr" v-for="item in tableData.value" :key="item.id">
				<b-td
					class="td"
					style="width: 10%; min-width: 10rem;vertical-align: middle;"
					><div style="cursor: pointer; color: #366092;" >
						<a :id="'btn-' + item.id">{{item.donorName}}</a>
					</div>
				</b-td>
				<b-td class="td" style="width: 80%"
					><div class="cell">
						{{ item.rank }}
					</div>
				</b-td>
				<b-popover
					placement="rightbottom"
					boundary="viewport"
					:target="'btn-' + item.id"
					triggers="hover focus"
					@show="getcharacterInfo(item.characterId)"
				>
					<div class="popover-wrap p-4">
						<div class="header">
							<div class="header-img">
								<img
									style="border-radius: 10%"
									width="100%"
									height="100%"
									:src="characterInfo.photoUrl"
									alt="" />
							</div>
							<div class="header-text">
								<div>
									<div class="name">
										{{ characterInfo.donorName }}
									</div>
									<div class="ename">
										{{characterInfo.EnName}}
									</div>
								</div>
								<div class="info">
									{{ characterInfo.rank }}
								</div>
							</div>
						</div>
						<div
							class="content"
							v-html="characterInfo.detailedIntroduction"
						>
							<!-- {{character.detailedIntroduction}} -->
						</div>
					</div>
				</b-popover>
			</b-tr>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		tableData: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			items: [],
			characterInfo: {},
		}
    },
   
    methods:{
     //人物详情
        getcharacterInfo(id){
		
            this.$api.characterInfo({
                id: id,
            }).then(res=>{
                console.log(res.data)
				this.characterInfo = res.data
            })
        },
    }
}
</script>
<style lang="scss">
.popover {
	box-shadow: 0 1px 15px rgb(18 21 21 / 20%);
	max-width: 200rem !important;
	height: 30rem;
	overflow-x: hidden;
	overflow-y: auto;
	border: none;
}
.popover-wrap {
	.header {
		display: flex;
		.header-img {
			flex: 1;
			min-width: 10rem;
			min-height: 10rem;
			max-width: 15rem;
			max-height: 15rem;
			margin-right: 1rem;
		}
		.header-text {
			flex: 2;
			.name {
				margin-bottom: 0.8rem;
				font-size: 1.2rem;
				font-weight: bold;
				color: #666666;
			}
			.ename {
				margin-bottom: 0.8rem;
				font-size: 1.1rem;
				color: #666666;
			}
			.info {
				margin-bottom: 0.8rem;
				font-size: 1rem;
				color: #999999;
			}
		}
	}
	.content {
		width: 43rem;
		margin: 1.2rem auto;
		font-size: 0.6rem;
		color: #999999;
		line-height: 2rem;
	}
}
.table td {
	padding: 0.2rem 0;
	vertical-align: top;
	text-align: center;
	border-top: none;
	border-bottom: 0.1rem solid #928f8e;
	border-left: none;
	border-right: none;
}
.table {
	.title {
		margin: 2rem 0;
		font-size: 1rem;
		color: #cfaf75;
		font-weight: bold;
	}
	.content {
		border-top: 0.1rem solid #928f8e;
		font-size: 1rem;
		min-height: 2rem;
		.cell {
			border-left: 0.1rem solid #a6a3a2;
			padding: 0 2rem;
			text-align: left;
			color: #666666;
		}
	}
}
@media (max-width: 768px) {
	.popover {
		max-width: 100rem !important;
	}
}
.info {
	    transform: translate(1rem, 3rem); 
	width: 25rem;
}
</style>
